import type { FilterState } from './types';

export const DEFAULT_FILTERS: FilterState = {
  activityTypes: [],
  appointmentTypeIds: [],
  sourceTypes: [],
  statusTypes: [],
  startDate: '',
  endDate: '',
};
